export default __webpack_public_path__ + "static/media/information_icon_light.9701b8ad.svg";